import './gourmetinc/style';
import FormStructure from './gourmetinc/form_structure';

export default FormStructure;